"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraftEditContainer = void 0;
const react_1 = __importStar(require("react"));
const DraftForm_1 = require("./DraftForm");
const react_router_dom_1 = require("react-router-dom");
const sdk_1 = require("../../sdk");
const DraftEdit = ({ draft, onSave, onDelete }) => {
    return (react_1.default.createElement("div", { className: "draft-edit" },
        react_1.default.createElement("div", { className: "draft-edit__actions" },
            react_1.default.createElement("a", { href: `/drafts/${draft.id}` }, "\u2190 Back to the draft"),
            react_1.default.createElement("span", { className: "draft-edit__delete", onClick: () => {
                    if (confirm('Are you sure?')) {
                        onDelete();
                    }
                } }, "Delete")),
        react_1.default.createElement(DraftForm_1.DraftForm, { title: draft.title, content: draft.content, onSubmit: onSave, type: DraftForm_1.DraftFormType.Edit })));
};
exports.DraftEditContainer = () => {
    const [draft, setDraft] = react_1.useState();
    const match = react_router_dom_1.useRouteMatch();
    const draftId = (match === null || match === void 0 ? void 0 : match.params).id;
    if (draft) {
        return (react_1.default.createElement(DraftEdit, { draft: draft, onSave: (title, content) => {
                sdk_1.sdk.updateDraft(draft.id, title, content)
                    .then(() => window.routerHistory.push(`/drafts/${draft.id}`))
                    .catch(sdk_1.sdk.reportClientError);
            }, onDelete: () => {
                sdk_1.sdk.deleteDraft(draft.id)
                    .then(() => window.routerHistory.push('/drafts'))
                    .catch(sdk_1.sdk.reportClientError);
            } }));
    }
    else {
        sdk_1.sdk.getDraft(draftId).then(setDraft).catch(sdk_1.sdk.reportClientError);
        return react_1.default.createElement("div", null); // TODO loader?
    }
};
//# sourceMappingURL=DraftEdit.js.map